var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0423 14.8965V6.7506C15.6642 7.91417 17.6111 8.53784 19.6072 8.53323V5.43305C18.428 5.18401 17.3617 4.55836 16.569 3.65042C15.936 3.24091 15.393 2.7067 14.9732 2.08038C14.5534 1.45406 14.2657 0.748779 14.1275 0.00756836H11.198V16.0516C11.1694 16.7499 10.9241 17.4221 10.496 17.9746C10.0679 18.5271 9.47829 18.9325 8.80917 19.1345C8.14005 19.3365 7.42462 19.325 6.7623 19.1017C6.09999 18.8784 5.52369 18.4543 5.1135 17.8884C4.44958 17.5389 3.92158 16.9775 3.61344 16.2934C3.3053 15.6093 3.23472 14.8418 3.41292 14.113C3.59111 13.3842 4.00786 12.7359 4.59689 12.2711C5.18592 11.8064 5.91342 11.5519 6.66369 11.5482C7.00018 11.5512 7.33442 11.6035 7.65577 11.7033V8.60298C6.23014 8.62716 4.84233 9.06561 3.66157 9.86488C2.48082 10.6642 1.55812 11.7897 1.00599 13.1043C0.453855 14.4189 0.296144 15.8658 0.552083 17.2684C0.808022 18.6711 1.46655 19.969 2.44738 21.0039C3.69317 21.8453 5.16852 22.2811 6.67153 22.2518C10.7362 22.2518 14.0337 18.9612 14.0423 14.8965Z",
  fill: "black",
  stroke: "black"
});

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.c96d58b51c4b9d1c611db06006b45c0a.svg";
export { ForwardRef as ReactComponent };